import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {AsyncPipe, NgIf} from '@angular/common';
import {HelpDocsLinksComponent} from '@shared/help-docs-links/help-docs-links.component';

@Component({
    selector: 'app-expand-collapse',
    templateUrl: './expand-collapse.component.html',
    styleUrls: ['./expand-collapse.component.css'],
    imports: [
        HelpDocsLinksComponent,
        NgIf,
        AsyncPipe
    ]
})
export class ExpandCollapseComponent implements OnInit {
  @Output() expandCollapse: EventEmitter<boolean> = new EventEmitter<boolean>();
  constructor() { }

  ngOnInit(): void {
  }

}
